<template>
  <div>
    <ButtonField text="添加" primary @click="addRow" :disabled="disabled"/>
    <div style="padding-top: 8px"></div>
    <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            @action="handleAction"
    >
        <template #template-type="{ item }">
            <span>{{ item.type === 'sewage' ? '污水' : '雨水' }}</span>
        </template>
        <template #template-location="{ item }">

            <SelectField style="width: 90%; margin: 0.5rem auto" label="" id="type" labelWidth="0"
                         :modelValue="item.location" :options="pipeTypeList"
                         @update:modelValue="(value) => handleModelValueUpdate('location', value)"
            />
        </template>
    </Tablelist>
  </div>
</template>
<script>
import store from "../mixins/store";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import Tablelist from "@/components/water-affairs-style/table-list.vue";
export default {
  mixins: [store],
  components: {
      ButtonField,Tablelist
  },
  props: {
    category: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      pipeTypeList: [
        {
          value: "from",
          name: "管道起点",
        },
        {
          value: "to",
          name: "管道终点",
        },
        {
          value: "in",
          name: "管道中间",
        },
      ],
      tableColumns:[
          {
              key: 'id',
              title: '编号',
              field: 'id',
              infotype: 'text'
          },
          {
              key: 'type',
              title: '分类',
              field: 'type',
              infotype: 'template'
          },
          {
              key: 'location',
              title: '位置',
              field: 'location',
              infotype: 'template'
          }
      ]
    };
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    addRow() {
      if (this.category && this.selectedPipe.category !== this.category) {
        this.$message.error("请选择同类型管线");
        return;
      }

      if (this.list.find((item) => item.id === this.selectedPipe.id)) {
        this.$message.error("请勿重复添加");
        return;
      }

      this.list.push({
        ...this.selectedPipe,
      });
    },

    onChange(val, index) {
      let target = this.list[index];
      this.list.splice(index, 1, {
        ...target,
        location: val,
      });
      this.$emit("change", this.list);
    },
    remove(index) {
      this.list.splice(index, 1);
      this.$emit("change", this.list);
    },
    handleAction(actionInfo) {
        const { type,  id } = actionInfo;
        switch(type) {
            case 'delete':
                this.remove(id);
                break;
        }
    },
    // select(row) {
    //   this.setSelectedPipe({
    //     id: row.id,
    //     type: row.category,
    //     startLnglat: [row.xfrom, row.yfrom],
    //     endLnglat: [row.xto, row.yto],
    //     _change: true,
    //   });
    // },
  },
};
</script>